import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NEVER, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserService } from '../services/user.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BaseResponse } from '../models';
const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private cookieService: CookieService, private userService: UserService, private router: Router) {

  }

  intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    const idToken = localStorage.getItem('aap_user_token');
    //let cloned = req.clone({
    //  headers: new HttpHeaders({       
    //    'Cache-Control': 'no-cache',
    //    'Pragma': 'no-cache',
    //    'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //  })
    //});
    // TEMP: auth disabled for testing
    return next.handle(req);
    // if (idToken) {
    //   const cloned = req.clone({
    //     headers: req.headers.set("Authorization",
    //       "Bearer " + idToken)
    //   });
    //   return next.handle(cloned).pipe(catchError(err => {
    //     if (err.status === 401) {
    //       this.userService.logoutUnAuthorized();
    //       return NEVER;
    //     }
    //     else {
    //       return next.handle(req);
    //     }
    //   }));
    // }
    // else {
    //   return next.handle(req);
    // }
  }

  //refreshTokenIfAboutToExpire() {
  //  var token = this.authService.getToken();
  //  var isAuthenticated = this.authService.isAuthenticated();
  //  if (token) {
  //    if (isAuthenticated) {
  //      var a: Date = jwtHelper.getTokenExpirationDate(token);
  //      var now: Date = new Date();
  //      var diffMs = (a.getTime() - now.getTime()); // milliseconds between now & expiration time
  //      var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
  //      if (diffMins <= 10) {
  //        this.userService.refresh().subscribe(response => {
  //          this.userService.saveToken(response.token);
  //        });
  //      }
  //    }
  //    else {
  //      this.userService.logout();
  //      location.reload();
  //    }
  //  }
  //}
}
